import { RUPEE, AED, DOLLAR, QAR, SAR } from '../constants/currency-symbol';

export const getCurrencySymbol = (currencyCode: string) => {
  switch (currencyCode) {
    case 'INR':
      return RUPEE;
    case 'USD':
      return DOLLAR;
    case 'AED':
      return AED;
    case 'SAR':
      return SAR;
    case 'QAR':
      return QAR;
    default:
      return currencyCode;
  }
};
